import React from 'react';
import { TeamMemberInfo, specialityOptions } from './utils';

interface SpecialityProps {
  memberInfo: TeamMemberInfo;
  setMemberInfo: (info: TeamMemberInfo) => void;
}

const Speciality: React.FC<SpecialityProps> = ({
  memberInfo,
  setMemberInfo,
}) => {
  return (
    <div>
      <h2 className="govuk-heading-m">Speciality</h2>
      <div className="flex gap-5 items-end">
        <div className="govuk-form-group">
          <label className="govuk-label" htmlFor="select-team-member-role">
            The specialty of the professional e.g. physiotherapy, oncology,
            mental health etc.
          </label>
          <select
            className="govuk-select govuk-!-width-full"
            id="select-team-member-role"
            name="selecttedRole"
            aria-describedby="role-hint role-error"
            value={memberInfo.speciality}
            onChange={e =>
              setMemberInfo({ ...memberInfo, speciality: e.target.value })
            }
          >
            <option value="" disabled>
              Select speciality
            </option>
            {specialityOptions.map(option => {
              return (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
};

export default Speciality;
